import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';
import CustomsBrokerFormModal from './CustomsBrokerFormModal.jsx';
import { displayPhone } from '../../phone.js';

const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>;

export default function CustomsBrokerList() {
  const [rows, setRows] = useState(null);
  const [query, setQuery] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  function load() {
    setRows(null);
    api('/dispatch/customs-brokers').then(setRows).catch(() => setRows([]));
  }

  const deleteRow = async (e, r) => {
    e.stopPropagation();
    if (!window.confirm(`Delete "${r.name}"? This can't be undone.`)) return;
    await api(`/dispatch/customs-brokers/${r.id}`, { method: 'DELETE' });
    load();
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    if (!rows) return [];
    const q = query.trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(r => [r.name, r.ref_number, r.license_number, r.contact_name].filter(Boolean).some(v => v.toLowerCase().includes(q)));
  }, [rows, query]);

  return (
    <div>
      <PageHeader
        icon={Icon.control}
        title="Custom Brokers"
        subtitle="Customs clearance for cross-border US/Canada freight — not to be confused with Customer Broker"
        color={SECTION_COLOR.control}
        actions={<button className="primary-btn" onClick={() => { setEditing(null); setFormOpen(true); }}>+ New customs broker</button>}
      />

      <div className="panel filter-row-panel">
        <div className="filter-row">
          <input placeholder="Type to filter..." value={query} onChange={e => setQuery(e.target.value)} style={{ width: 240 }} />
        </div>
      </div>

      {rows === null && <div className="empty">Loading...</div>}
      {rows && rows.length === 0 && <div className="empty">No customs brokers yet — click "+ New customs broker" above.</div>}

      {rows && rows.length > 0 && (
        <table>
          <thead>
            <tr><th>Ref#</th><th>Broker</th><th>Type</th><th>Contact</th><th>Phone</th><th>License #</th><th>Direction</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.map(r => (
              <tr key={r.id} onClick={() => { setEditing(r); setFormOpen(true); }} style={{ cursor: 'pointer' }}>
                <td>{r.ref_number || '—'}</td>
                <td>{r.name}</td>
                <td>{r.broker_country === 'US' ? 'US' : r.broker_country === 'Canada' ? 'Canada' : '—'}</td>
                <td>{r.contact_name || '—'}</td>
                <td>{displayPhone(r.phone) || '—'}</td>
                <td>{r.license_number || '—'}</td>
                <td>{r.direction_handled || '—'}</td>
                <td>{r.status || 'Active'}</td>
                <td>
                  <button type="button" title="Delete" onClick={e => deleteRow(e, r)}
                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--red)', cursor: 'pointer', padding: 0 }}>
                    <TrashIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {formOpen && (
        <CustomsBrokerFormModal customsBroker={editing} onClose={() => setFormOpen(false)} onSaved={() => { setFormOpen(false); load(); }} />
      )}
    </div>
  );
}
